import React, { useEffect, useState } from 'react';
import './Login.css';
import { Link, useNavigate } from 'react-router-dom';
import publicAxios from '../../utils/axios/publicAxios';
import Notification from '../../components/Notification/Notification';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ type: '', message: '' });
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const token = localStorage.getItem('token');

  const showNotification = (type, message) => {
    setNotification({ type, message });
    setTimeout(() => {
      setNotification({ type: '', message: '' });
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await publicAxios.post(`/public/login`, formData);

      // Assuming backend returns { message, userId, token, ... }
      const { message, userId, userRoles, token } = response.data;

      showNotification('success', message || 'Login successful!');
      setTimeout(() => {
        // Save to memory (you can later store token in context or Redux if needed)
        localStorage.setItem('userId', userId);
        localStorage.setItem('token', token);
        localStorage.setItem('userRoles', JSON.stringify(userRoles));
        navigate('/user-profile');
      }, 3000);

    } catch (error) {
      console.error('Login error:', error.response?.data || error.message);
      showNotification('error', error.response?.data?.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (token) {
      navigate('/user-profile');
    }
  }, [token, navigate]);

  return (
    <div className="login">
      <Notification
        type={notification.type}
        message={notification.message}
        onClose={() => setNotification({ type: '', message: '' })}
      />

      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>

        <div className="login-form-group">
          <label>Email:</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="login-form-group">
          <label>Password:</label>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            placeholder="Enter password"
            value={formData.password}
            onChange={handleChange}
            required
            className='login-password'
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </span>
        </div>

        <button type="submit" className="login-btn" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
        <Link to={'/forgot-password'}>Forgot password?</Link>
      </form>
    </div>
  );
};

export default Login;